import { Type } from "class-transformer"
import { ArrayNotEmpty, IsArray, ValidateNested } from "class-validator"
import type { HttpDto } from "~/http/http.models"
import { Technology } from "../technology.model"

export class TechnologiesDto implements HttpDto<Technology[]> {
  @Type(() => Technology)
  @IsArray()
  @ArrayNotEmpty()
  @ValidateNested({ each: true })
  declare readonly data: Technology[]
}
